import { cn } from "@gymflow/helpers";

import { Button } from "../Button";

export type TabType<T extends string | number> = {
  id: T;
  label: string;
};

export type TabsProps<T extends string | number> = {
  tabs: TabType<T>[];
  tabId: T;
  setTabId: (id: T) => void;
  className?: string;
};

export const PillTabs = <T extends string | number>({
  tabs,
  tabId,
  setTabId,
  className,
}: TabsProps<T>) => (
  <div
    className={cn(
      "flex flex-row gap-2 overflow-x-auto overflow-y-hidden p-1",
      className,
    )}
  >
    {tabs.map(({ id, label }) => (
      <Button
        intent={tabId === id ? "secondary-light" : "transparent"}
        key={id}
        onClick={() => setTabId(id)}
        className="h-9 min-w-fit px-3 text-sm"
      >
        {label}
      </Button>
    ))}
  </div>
);
